import CardAddContentButton from '@/components/ui/custom/CardAddContentButton';
import Lesson from '@/models/Lesson';
import { useTranslation } from 'react-i18next';

type LessonAddQuestionsButtonProps = Pick<Lesson, 'activities'> & {
  onAddQuestions?: () => void;
  isLimitedEdition?: boolean;
};

const LessonAddQuestionsButton = ({
  activities,
  onAddQuestions,
  isLimitedEdition = false,
}: LessonAddQuestionsButtonProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.courseWorkspace.unitsTab',
  });

  return (
    <CardAddContentButton
      label={t('addQuestions')}
      count={activities.length}
      onClick={onAddQuestions}
      isLimitedEdition={isLimitedEdition}
    />
  );
};

export default LessonAddQuestionsButton;
